import {
  Paper,
  Stack,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import React, { useState } from 'react';
import MyTableBoldCell from '../../../components/material-ui/adaptive/MyTableBoldCell';
import { useTranslation } from 'react-i18next';
import MyTableCell from '../../../components/material-ui/adaptive/MyTableCell';
import { getOnlyData } from '../../../utils';
import dayjs from 'dayjs';
import ShowContainer from '../../../components/material-ui/ShowContainer';
import LogSymbolsModal from '../modal/LogSymbolsModal';
import CusInput from '../../../components/material-ui/CusInput';
import TypographyLink from '../../../components/material-ui/table/TypographyLink';
import MyTableBody from '../../../components/material-ui/adaptive/MyTableBody';

export default function LogsTable({
  logs,
  eventFiltered,
  setEventFiltered,
  getColorRow,
  getNumberRow
}) {
  const { t } = useTranslation();
  const [openSymbols, setOpenSymbols] = useState(false);

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ display: 'table', width: '100%' }}>
            <TableRow>
              <MyTableBoldCell sx={{ pr: 0 }} isLess>
                #
              </MyTableBoldCell>
              <MyTableBoldCell isLess>{t('Date')}</MyTableBoldCell>
              {/* <MyTableBoldCell isLess> </MyTableBoldCell> */}
              <MyTableBoldCell isLess>
                <Stack direction={'row'} gap={1} alignItems={'center'}>
                  <Typography fontWeight={900}>{t('Event')}</Typography>
                  <Stack flex={1}>
                    <CusInput
                      value={eventFiltered}
                      onChange={(e) => setEventFiltered(e.target.value)}
                    />
                  </Stack>
                </Stack>
              </MyTableBoldCell>
            </TableRow>
          </TableHead>
          <MyTableBody maxHeight={{ maxHeight: 'calc(100svh - 280px - 100px - 40px)' }}>
            {logs?.map((el, indx) => (
              <TableRow
                key={indx}
                sx={{
                  cursor: 'pointer',
                  background: getColorRow(el[1]),
                  '&:hover': { backgroundColor: 'action.hover' }
                }}>
                <MyTableCell sx={{ width: 60, pr: 0 }}>{getNumberRow(indx)}</MyTableCell>
                <MyTableCell sx={{ width: 115, p: 1 }}>
                  <Typography fontSize={12} color="textSecondary">
                    {getOnlyData(dayjs(el[0]), '', 'DD.MM.YYYY HH:mm')}
                  </Typography>
                </MyTableCell>

                <MyTableCell isLess>
                  <Stack flex={1}>
                    <Typography sx={{ wordBreak: 'break-all' }} fontSize={13}>
                      {el[2]}{' '}
                      <ShowContainer condition={el[3]?.symbols}>
                        <TypographyLink
                          component={'span'}
                          onClick={() => setOpenSymbols({ ...el[3]?.symbols, indx: indx + 1 })}>
                          {t('Symbols')}
                        </TypographyLink>
                      </ShowContainer>
                    </Typography>
                  </Stack>
                </MyTableCell>
              </TableRow>
            ))}
          </MyTableBody>
        </Table>
      </TableContainer>

      <LogSymbolsModal openSymbols={openSymbols} setOpenSymbols={setOpenSymbols} />
    </>
  );
}
